import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import ParityTooltipsTooltipParityOverviewTable from 'lumen/components/parity/tooltips/tooltip-parity-overview-table';

interface GeneralTablesCellsCellHotelRateSignature {
  Args: {
    paritiesBaseratesDict: unknown;
    periodId: unknown;
  };
}

export default class GeneralTablesCellsCellHotelRate extends Component<GeneralTablesCellsCellHotelRateSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get baseRate() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.paritiesBaseratesDict[this.args.periodId];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hotelRate() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return this.hotelAndMarketService.formatRate(this.baseRate);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isHotelRateAvailable() {
    return this.baseRate !== undefined;
  }

  <template>
    <div class="flex items-center justify-center">
      {{#if this.isHotelRateAvailable}}
        {{this.hotelRate}}
        <ParityTooltipsTooltipParityOverviewTable
          @formattedRate={{this.hotelRate}}
          @issue={{this.baseRate}}
          @message={{this.baseRate.message}}
        />
      {{else}}
        {{t "general.missing"}}
      {{/if}}
    </div>
  </template>
}
